import React, { useEffect, useMemo } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    useLocation,
    withRouter,
} from "react-router-dom";

import { AnimatePresence, motion } from 'framer-motion';

function _ScrollToTop(props) {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return props.children
}

const ScrollToTop = withRouter(_ScrollToTop)

const ScrollBlock = React.memo((props) => {
    const { 
        children,
        pageTransition = {
            in: {
                opacity: 1
            },
            out: {
                opacity: 0
            }
        }
    } = props;



    return(
            <ScrollToTop>
                <motion.div
                    className="PageContent"
                    variants={pageTransition}
                    exit="out"
                    animate="in"
                    initial="out"
                >
                    {children}
                </motion.div>
            </ScrollToTop>
    )
});

export default ScrollBlock;